import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { BsGithub } from 'react-icons/bs';
import { RiInstagramFill } from 'react-icons/ri';
const HeaderSocials = () => {
    return (
        <div className="header__socials">
            <a href="https://www.linkedin.com/in/rizkyanandafaradin/" target="_blank" rel="noreferrer">
                <BsLinkedin />
            </a>
            <a href="https://github.com/RizkyAnandaFaradin" target="_blank" rel="noreferrer">
                <BsGithub />
            </a>
            <a href="https://www.instagram.com/_nandarizkyf_/" target="_blank" rel="noreferrer">
                <RiInstagramFill />
            </a>
        </div >
    );
};

export default HeaderSocials;
